export function getIframeCode(url: string) {
    return (
        "<iframe frameborder='0' height='450px' width='320px' src='" +
        url +
        "' scrolling='no'></iframe>"
    );
}
